// extracted by mini-css-extract-plugin
export default {"none":"_2ugmGoOvf5"};
    if(module.hot) {
      // 1623933191054
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  